/* import __COLOCATED_TEMPLATE__ from './heatmap-tooltip.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();